<div class="container relative py-2">
  <ngx-spinner name="load" [fullScreen]="false" type="timer"></ngx-spinner>
  <div class="d-flex justify-content-between align-items-center p-1">
    <label>
      <input type="search" [(ngModel)]="keyword" (debounce)="load()">
    </label>
    <div *ngIf="keyword && criteria?.Keyword && jobs?.length" class="pointer btn" (confirm)="rejectAll()">
      <i class="fa fa-times f-red fs-xl mx-2"></i>
      حذف همه‌ی جستجو شده‌ها
    </div>
    <app-pagination [total]="total" (page)="load($event)" [limit]="limit"></app-pagination>
  </div>
  <div class="p-2">
    <div class="p-2 border-bottom" *ngFor="let job of jobs;let i=index;trackBy:trackByFn">
      <i class="fa fa-times f-red fs-xl mx-2 pointer" (click)="setStatus(job.Id, JobStatus.Rejected, i)"></i>
      <i class="fa fa-check f-green fs-xl mx-2 pointer" (click)="setStatus(job.Id, JobStatus.Started, i)"></i>
      <i class="fa fa-star f-blue fs-xl mx-2 pointer" (contextmenu)="setStatus(job.Id, JobStatus.Rejected, i, $event)"
        (click)="setStatus(job.Id, JobStatus.Started, i)" title="کلیک راست مرجوع | کلیک چپ تایید"></i>
      <div class="row">
        <div class="col-8">
          <div class="d-flex justify-content-between align-items-center fs-sm">
            <h6>{{job.Title}}</h6>
            <span>KP{{job.Code}}</span>
            <span>{{job.RegisterTime | pdate}}</span>
          </div>

          <div *ngIf="job.Description" [innerHTML]="job.Description  " class="overflow-auto wrap"
            style="max-height: 200px;">
          </div>
          <div *ngIf="!job.Description" class="f-gray">
            بدون متن
          </div>
        </div>
        <div class="col-4">
          <div>
            <a class="btn btn-white" [routerLink]="['/admin','ads','save',job.Id]" target="_blank">ویرایش</a>
          </div>
          <div class="form-group clearfix">
            <div>شهر:</div>
            <app-location name="location" accept-level="Globe" [(ngModel)]="jobs[i]"></app-location>
          </div>
          <div>
            <a [href]="job.SourceUrl" target="_blank" class="overflow-auto "> لینک منبع اصلی:
              <div class="text-left" dir="ltr">
                {{job.SourceUrl}}
              </div>
            </a>
          </div>
        </div>
      </div>


    </div>

  </div>
</div>